import {
  HHAccordion,
  HHAccordionDetails,
  HHAccordionSummary,
  HHTypography,
} from '@hinge-health/react-component-library';
import { ExpandMore } from '@mui/icons-material';
import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { cleanTypeNameGraphql } from '../utils/graphql-utils';

interface JsonAccordionProps {
  data: Record<string, unknown>;
  title: string;
}

const JsonAccordion = ({ data, title }: JsonAccordionProps): JSX.Element => (
  <HHAccordion
    disableGutters
    sx={(theme): SystemStyleObject<Theme> => ({
      boxShadow: 'none',
      '&:before': {
        display: 'none',
      },
      backgroundColor: theme.palette.background.paper,
    })}
  >
    <HHAccordionSummary
      expandIcon={<ExpandMore />}
      sx={{
        padding: 0,
        margin: 0,
      }}
    >
      <HHTypography hhVariant="subtitle1" fontSize={10} fontWeight="bold">
        {title}
      </HHTypography>
    </HHAccordionSummary>
    <HHAccordionDetails>
      <HHTypography
        hhVariant="variant-bypass"
        variant="body2"
        fontSize={11}
        sx={{
          whiteSpace: 'pre-wrap',
          fontFamily: 'monospace',
        }}
      >
        {JSON.stringify(cleanTypeNameGraphql(data), null, 2)}
      </HHTypography>
    </HHAccordionDetails>
  </HHAccordion>
);

export default JsonAccordion;
